import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import {
  AssetDetails,
  Hub,
  LivePlayer,
  Placeholder,
  Player,
  VOD,
} from '../Views'
import { PARTNER_IDENTIFIER } from "../services/partners";
import { PLACEHOLDER_IMAGE } from '../Views/Placeholder'

const Routes = () => {
  const location = useLocation();

  const PARTNERS_PATH = Object.values(PARTNER_IDENTIFIER).join("|");

  return (
    <AnimatePresence initial={false}>
      <Switch location={location}>
        <Route path="/" exact component={Hub} />
        <Route path="/live-tv" component={Hub} />
        <Route path="/vod" component={VOD} />
        <Route
          path={`/asset/:partner(${PARTNERS_PATH})/:id`}
          component={AssetDetails}
        />
        <Redirect exact path="/asset" to="/" />
        <Route
          path={`/player/:partner(${PARTNERS_PATH})/:id`}
          component={Player}
        />
        <Redirect exact path="/player" to="/" />
        <Route
          path={`/live/:channelId?`}
          component={LivePlayer}
        />
        <Route path={`/:type(${Object.keys(PLACEHOLDER_IMAGE).join('|')})`} component={Placeholder} />
      </Switch>
    </AnimatePresence>
  );
};

const pageStyle = {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  overflow: "hidden",
};

const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 0.5,
};

const View = ({ children, style, className }) => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
      className={className}
      style={{ ...pageStyle, ...style }}
    >
      {children}
    </motion.div>
  );
};

export { Routes, View };
